import { BetProductWithSportsbook, PlayerProp, SportsbookType } from '@pff-consumer/schema'
import { useDispatch, useSelector } from 'react-redux'
import {
  addToBetsCart,
  bettingSelectors,
  clearAllBets,
  clearBetsCartForSportsbook,
  closeBetsCartScreen,
  openBetsCartScreen,
  closeBetLimitModal,
  removeFromBetsCart,
  setEventsLockoutState,
  setSportsbookState,
  setSelectedEventId,
} from './betting.slice'

export const bettingHooks = {
  useBetsCartState: () => useSelector(bettingSelectors.getBetsCartState),
  useBetSlipCount: () => useSelector(bettingSelectors.getBetSlipCount),
  useCartBetCategoryCount: () => useSelector(bettingSelectors.getCartBetCategoryCount),
  useCartBetDetailedTypeCount: () => useSelector(bettingSelectors.getCartDetailedBetTypeCount),
  useCartBetGeneralTypeCount: () => useSelector(bettingSelectors.getCartGeneralBetTypeCount),
  useCartGameIdCount: () => useSelector(bettingSelectors.getCartGameIdCount),
  useCartTeamCount: () => useSelector(bettingSelectors.getCartTeamCount),
  useCartGameTimesCount: () => useSelector(bettingSelectors.getCartGameTimesCount),
  useLockedEventsState: () => useSelector(bettingSelectors.getLockedEventsState),
  useSelectedEventId: () => useSelector(bettingSelectors.getSelectedEventId),
  useSportsbookId: () => useSelector(bettingSelectors.getSportsbookId),
  useBettingActions: () => {
    const dispatch = useDispatch()
    return {
      addToBetsCart: (payload: BetProductWithSportsbook | PlayerProp) => {
        dispatch(addToBetsCart(payload))
      },
      removeFromBetsCart: (payload: BetProductWithSportsbook | PlayerProp) => {
        dispatch(removeFromBetsCart(payload))
      },
      clearAllBets: () => {
        dispatch(clearAllBets())
      },
      clearBetsCartForSportsbook: (payload: SportsbookType) => {
        dispatch(clearBetsCartForSportsbook(payload))
      },
      openBetsCartScreen: () => {
        dispatch(openBetsCartScreen())
      },
      closeBetsCartScreen: () => {
        dispatch(closeBetsCartScreen())
      },
      closeBetLimitModal: () => {
        dispatch(closeBetLimitModal())
      },
      disableEventsLockout: () => {
        dispatch(setEventsLockoutState(false))
      },
      enableEventsLockout: () => {
        dispatch(setEventsLockoutState(true))
      },
      setSelectedEventId: (payload: number | undefined) => {
        dispatch(setSelectedEventId(payload))
      },
      setSportsbookId: (payload: SportsbookType) => {
        dispatch(setSportsbookState(payload))
      },
    }
  },
}
